import axios from 'axios';
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
// 设置公共请求头

const init = function () {
  const CancelToken = axios.CancelToken;
  const source = CancelToken.source();
  Vue.use(ElementUI);
  const  vue=new Vue();
  function getCookie(name) {
    var arr, reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
    if (arr = document.cookie.match(reg)) {
      return unescape(arr[2]);
    } else {
      return "";
    }
  }
  let token=document.cookie;
  const cookieReg=/OAToken=(\w.[^;]*)/; //cookie匹配
  // console.log('token',cookieReg.exec(token))
    if (cookieReg.exec(token)==null) {
        token="";
    } else {
        token=cookieReg.exec(token)[1];
    }

  // 下面的参数有Authorization
 axios.defaults.headers.common["Authorization"]="Basic "+token;

  axios.interceptors.response.use(
    response => {
      console.log(response.request);
      // console.log(response,"4564677+++++++")
       // 调用方在请求配置中传 rawResponse: true 时，跳过统一处理，直接返回完整响应
       if(response.config && response.config.rawResponse){
            return response
      }

      if (response.data instanceof Object) {
        var data = response.data;
      } else {
        var data = JSON.parse(response.data)
      }


      //console.log(response.config.headers.Authorization,"779879")

      switch (data.status) {
        case 101: {

          if(data.results.url.indexOf('company')>-1){
            window.location.href = data.results.url
          }else{
            return response
          }

        }; break;//强制跳转页面
        case 102: {
          alert(data.results);
        }
          ;
          break;//强制提示信息
        case 200: {
          return response
        }
          ;
          break;//正常信息
        case 500: {
          alert(data.results.exception)
        }
          ;
          break;//异常信息
        default:
          return response;
          break;
      }


    },
    error => {
      console.log(error.response, 'error.response')
      console.log(error, 'error')
      return Promise.reject((error.response || error))   // 返回接口返回的错误信息
    })



}

export default {
  init
}



// WEBPACK FOOTER //
// ./src/common/request.js